import React from 'react';
import ClickHandlerWithLoaderContainer from '../../../../Common/ClickHandlerWithLoader/ClickHandlerWithLoaderContainer';
import SettingsRow from '../../../Common/SettingsRow/SettingsRow';
import { getI18N } from 'qs-services/i18N';

export default ({ onSelected, settingComponentId, classForContainer }) => {
  const { t } = getI18N();

  return (
    <ClickHandlerWithLoaderContainer
      clickProps={{
        clickHandler: onSelected,
        clickParams: settingComponentId
      }}
      type="button"
      classForContainer={classForContainer}
    >
      <SettingsRow
        imageSrc={'https://web.quicksell.co/static/media/ic_quicksell_shipping_cost.svg'}
        title={t('shipping_cost_settings')}
      >
        <span>{t('collect_shipping_cost_from_your_customers')}</span>
      </SettingsRow>
    </ClickHandlerWithLoaderContainer>
  );
};
